var map = {
	"./Mock 1.png": 8184,
	"./Mock 2.png": 61424,
	"./Mock 3.png": 40862,
	"./Mock 4.png": 21167,
	"./Mock 5.png": 86736,
	"./Mock 6.png": 67654,
	"./Mock 7.png": 32810,
	"./OGprofilepic.png": 94553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13435;